const $timeline = $('.section-timeline ol');
const $prev = $('.section-timeline .arrow__prev');
const $next = $('.section-timeline .arrow__next');
const xScrolling = 180;

export function timeline() {
  if($timeline.length > 0) {
    $(window).on('load resize', function () {
      init();
    });
  }
}

function init(){
  let counter = 0;
  let containerWidth = $('.section-timeline ol').width();
  let scrollWidth = $('.section-timeline .timeline-content')[0].scrollWidth;
  let scrollLimit = scrollWidth - containerWidth;
  scrollLimit = Math.ceil(scrollLimit / xScrolling);

  $prev.addClass('disabled');
  $next.addClass('disabled');

  if(scrollWidth > containerWidth){
    $next.removeClass('disabled');
  }

  $timeline.css('transform', 'translateX(0)');

  $next.off('click').on('click', function(){
    if($(this).hasClass('disabled')){
      return false;
    }

    counter++;
    let margin = counter * xScrolling;
    $timeline.css('transform', 'translateX(-'+margin+'px)');
    $prev.removeClass('disabled');

    if(counter >= scrollLimit) {
      $next.addClass('disabled');
    }
  })

  $prev.off('click').on('click', function(){
    if($(this).hasClass('disabled')){
      return false;
    }

    counter--;
    let margin = counter * xScrolling;
    $timeline.css('transform', 'translateX(-'+margin+'px)');
    $next.removeClass('disabled');

    if(counter == 0) {
      $prev.addClass('disabled');
    }
  });
}



// WEBPACK FOOTER //
// ./scripts/components/timeline.js